function Order({ order }) {
    if (!order) {
        return null;
    }

    console.log(order)

    return (
      <>
          <h2 className='info-heading'>Pasūtījuma #{order.id} informācija:</h2>
          <table className='order-info-table'>
            <tbody>
              <tr>
                <td>Numurs:</td>
                <td>{order.id}</td>
              </tr>
              <tr>
                <td>Pasūtītājs:</td>
                <td>{order.billing.last_name}, {order.billing.first_name}</td>
              </tr>
              <tr>
                <td>Datums:</td>
                <td>{order.date_created.split('T')[0]}</td>
              </tr>
              <tr>
                <td>Apmaksas veids::</td>
                <td>{order.payment_method_title}</td>
              </tr>
              <tr>
                <td>Prece bez PVN:</td>
                <td>€{(order.total - order.total_tax - order.shipping_total).toFixed(2)}</td>
              </tr>
              <tr>
                <td>PVN 5%:</td>
                <td>€{Number(order.cart_tax).toFixed(2)}</td>
              </tr>
              <tr>
                <td>Piegāde bez PVN:</td>
                <td>€{Number(order.shipping_total).toFixed(2)}</td>
              </tr>
              <tr>
                <td>PVN 21%:</td>
                <td>€{Number(order.shipping_tax).toFixed(2)}</td>
              </tr>
              <tr>
                <td>Summa:</td>
                <td>€{Number(order.total).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </>
    )
  }
  
export default Order